import SummaryByBranch from "./summary-by-branch.container";

export default SummaryByBranch;
